import DailySessionCalendar from './components/DailySessionCalendar.vue'

/**
 * Register exchange-module Nova Vue cards.
 *
 * @param {import('vue').App} app
 */
const exchangesModuleSetup = (app) => {
  app.component('daily-session-calendar', DailySessionCalendar)
}

export { exchangesModuleSetup }
